import React, { useMemo } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useGetUserGroupsQuery } from '../../../../../../api';
import { useLanguage } from '../../../../../../contexts/LanguageContext';

/**
 * Regional Manager User Dropdown
 * Tek seçim — userId döner
 */
const RegionalManagerUserDropdown = ({ value, onChange, className = '', disabled = false }) => {
    const { th } = useLanguage();
    var placeholder = th('customerAddressBrand.tabs.regionalManager.dialog.placeholder.userDropdown');

    const { data: userGroupsResponse, isLoading } = useGetUserGroupsQuery();

    const userOptions = useMemo(() => {
        return (
            userGroupsResponse?.data?.map((user) => ({
                id: user.id,
                name: user.name,
                displayValue: `${user.id} - ${user.name}`
            })) || []
        );
    }, [userGroupsResponse?.data]);

    return (
        <Dropdown
            value={userOptions.find((opt) => opt.id === value) || null}
            options={userOptions}
            onChange={(e) => onChange(e.value?.id)}
            optionLabel="displayValue"
            filter
            showClear
            className={className}
            placeholder={placeholder}
            loading={isLoading}
            disabled={disabled}
            filterBy="id,name"
            itemTemplate={(option) => (
                <div>
                    <span style={{ fontWeight: 'bold' }}>{option.id}</span> - {option.name}
                </div>
            )}
        />
    );
};

export default RegionalManagerUserDropdown;
